import { useMutation } from "@tanstack/react-query";

import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Estado } from "../../actions/Estado";
import style from "../../styles/form.module.css";

function ABMCompanias() {
   const token = localStorage.getItem("token");
   const url = process.env.REACT_APP_URL_DIR + "compania";
   const urlUsr = process.env.REACT_APP_URL_DIR + "registernoAUth";
   const urlUsuario = process.env.REACT_APP_URL_DIR + "sqlraw/sql";

   const [respuesta, setRespuesta] = useState("");
   const [mailError, setMailError] = useState("");
   const [codeError, setDocumento] = useState("");
   var urlCli = url;
   var metodo = "POST";
   // const urlProd = process.env.REACT_APP_URL_DIR + "estadosproducto";
   const estados = Estado();
   // const queryClient = useQueryClient();

   const location = useLocation();
   const { state } = location;
   const navigate = useNavigate();

   const { mutate: graboDatosDefault } = useMutation({
      mutationFn: () =>
         fetch(urlCli, {
            method: "POST",
            body: JSON.stringify(),
         }).then((res) => res.json()),
      onSuccess: (req) => {
         console.log("onSuccess ", req);
         if (req.errors) {
            for (let ix = 0; ix < req.errors.length; ix++) {
               if (req.errors[ix].path === "email")
                  setMailError(req.errors[ix].msg);
               if (req.errors[ix].path === "documento")
                  setDocumento(req.errors[ix].msg);
            }
         } else {
            if (req.message) {
               setRespuesta(req.message);
            }
            // window.location.href = "/compania";
         }
      },
      onError: () => {
         alert("Error");
      },
   });

   const [input, setInput] = useState({
      // id_primary: state ? state.id_primary : 0,
      id: state ? state.id : 0,
      code: state ? state.code : "",
      razsoc: state ? state.razsoc : "",
      email: state ? state.email : "",
      movil: state ? state.movil : "",
      fijo: state ? state.fijo : "",
      cod_status: state ? state.cod_status : "1",
   });

   // const { data, isLoading } = useQuery({
   //    queryKey: ["usuario"],
   //    queryFn: () =>
   //       fetch(`${urlUsuario}\${usuario.id}` , {
   //          headers: {
   //             Authorization: `Bearer ${token}`, //mind the space before your token
   //          },
   //       }).then((res) => res.json(), console.log("busco datos")),
   //    });
   // if (isLoading){
   //    return <div>Loading...</div>
   // }

   // console.log('usuario leido: ', data);

   const [usuario, setUsuario] = useState({
      id: 0,
      companyId: state ? state.id : 0,
      username: "",
      email: "",
      passwordHash: "",
      perfiles: [1],
      estadoId: 1,
      id_rank: 0,
   });

   useEffect(() => {
      async function fetchUsuario() {
         var sql = `select users.*  from users `;
         sql += ` join userperfilrel on "userId" = id`;
         sql += ` where "companyId" =${input.id} `;
         sql += `  and "perfilId" = 1`;
         console.log("input: ", input, sql);
         const response = await fetch(`${urlUsuario}/${sql}`, {
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         });
         const data = await response.json();
         console.log("usuario leido: ", data);  
         setUsuario(Array.isArray(data) && data.length > 0 ? data[0] : {
            id: 0,
            companyId: input.id,
            username: "",
            email: "",
            passwordHash: "",
            perfiles: [1],
            estadoId: 1,
            id_rank: 0,
         });
      }
      fetchUsuario();
   }, []);
   
   
   var btnGrabar = true;

   // const { data } = useQuery({
   //    queryKey: ["get"],
   //    queryFn: () => fetch(urlProd,
   //       {
   //          headers: {
   //             "Authorization": `Bearer ${token}`, //mind the space before your token
   //          }}
   //       ).then((res) => res.json()),
   //       staleTime:30000,  // actualiza la pagina cada 30 segundos solo si salis y volves a entrar o se agrega info
   // });
   function generarDefault() {
      // console.log("input: ", input);
      urlCli = `${url}/new/${input.id}`;
      // console.log("urlCli: ", urlCli);
      graboDatosDefault();
   }
   function handleChange(e) {
      e.preventDefault();
      setInput({
         ...input,
         [e.target.name]: e.target.value,
      });
   }
   function handleChangeUser(e) {
      e.preventDefault();
      setUsuario({
         ...usuario,
         [e.target.name]: e.target.value,
      });
   }
   const handleSubmit = (e) => {
      e.preventDefault();
      urlCli = url + `/${input.id}`;
      metodo = "PUT";
      if (input.id === 0) {
         urlCli = url;
         metodo = "POST";
      }
      console.log("handleSubmit : ", input);
      mutate(input);
      // window.location.href = "/companias";
   };

   const handleSubmitUsr = (e) => {
      e.preventDefault();
      usuario.companyId = input.id;
      urlCli = urlUsr;
      metodo = "PUT";
      if (usuario.id === 0) {
         urlCli = urlUsr;
         metodo = "POST";
      }
      console.log("usuario: ", usuario);
      console.log("metodo: ", metodo);
      console.log("urlCli: ", urlCli);
      mutate(usuario);
      // window.location.href = "/compania";
   };
   const { mutate } = useMutation({
      mutationFn: (newPost) =>
         fetch(urlCli, {
            method: metodo,
            body: JSON.stringify(newPost),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: (req) => {
         console.log("onSuccess ", req);
         if (req.errors) {
            for (let ix = 0; ix < req.errors.length; ix++) {
               if (req.errors[ix].path === "email")
                  setMailError(req.errors[ix].msg);
               if (req.errors[ix].path === "code")
                  setDocumento(req.errors[ix].msg);
            }
         } else {
            console.log("ok");
            // window.location.href = "/companias";
         }
      },
      onError: () => {
         alert("Error");
      },
   });

   //console.log("input: ", input);
   // return (
   //    <>
   //       <div className="container">HOLA
   //       </div>
   //    </>
   // );

   console.log("input: ", input);
   return (
      <>
         <div>
            <div className="bg-white w-90">
               <form
                  onSubmit={(e) => handleSubmit(e)}
                  // className="form-style-Prod"
               >
                  <h1 style={{ textAlign: "center", color: "white" }}>
                     Datos del Compania
                  </h1>
                  <br />
                  <div>
                     {input.id.id !== 0 ? (
                        <div>
                           <span className={style.input_group_text}>
                              Compania id : {input.id}
                           </span>
                           <br />
                        </div>
                     ) : null}
                  </div>

                  <div className={style.input_group}>
                     <span className={style.input_group_text}>
                        Razon Social:{" "}
                     </span>
                     <input
                        className={style.input_field}
                        type="text"
                        placeholder="Ingrese Compania"
                        name="razsoc"
                        value={input.razsoc}
                        onChange={handleChange}
                        required
                     />
                  </div>
                  <div style={{ display: "block" }}>
                     <div className={style.input_group}>
                        <span className={style.input_group_text}>E-Mail: </span>
                        <input
                           className={style.input_field}
                           type="text"
                           placeholder="Email del Compania"
                           name="email"
                           value={input.email}
                           onChange={handleChange}
                           required
                        />
                     </div>
                     <div className={style.showerror}>
                        <p className={style.errormsg}>{mailError}</p>
                     </div>
                  </div>
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Telefono:</span>
                     <label htmlFor="email"></label>
                     <input
                        className={style.input_field}
                        type="text"
                        id="movil"
                        name="movil"
                        value={input.movil}
                        onChange={handleChange}
                     />
                  </div>
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Fijo:</span>
                     <label htmlFor="email"></label>
                     <input
                        className={style.input_field}
                        type="text"
                        id="fijo"
                        name="fijo"
                        value={input.fijo}
                        onChange={handleChange}
                     />
                  </div>

                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Status:</span>
                     <select
                        name="cod_status"
                        id="cod_status"
                        onChange={(e) => handleChange(e)}
                        value={input.cod_status}
                        className={style.input_field}
                     >
                        <option value="0">Seleccionar</option>
                        {estados &&
                           estados.map((dat) => {
                              return (
                                 <option
                                    selected
                                    value={dat.id}
                                    key={dat.id}
                                 >{`${dat.nombre}`}</option>
                              );
                           })}{" "}
                     </select>
                  </div>
                  <div>
                     {btnGrabar ? (
                        <button className={style.inputBtnNew} type="submit">
                           {state ? "GRABAR" : "AGREGAR"}
                        </button>
                     ) : null}
                  </div>
               </form>
            </div>
            <div>
               {input.id !== 0 ? (
                  <div className="bg-white w-90">
                     <form
                        onSubmit={(e) => handleSubmitUsr(e)}
                        // className="form-style-Prod"
                     >
                        <h1 style={{ textAlign: "center", color: "white" }}>
                           Datos del Administrador
                        </h1>
                        <br />
                        <div>
                           {usuario.id !== 0 ? (
                              <div>
                                 <span className={style.input_group_text}>
                                    Usuario id : {usuario.id}
                                 </span>
                                 <br />
                              </div>
                           ) : (
                              <div>
                                 <span>&nbsp;</span> <br />
                              </div>
                           )}
                        </div>

                        <div className={style.input_group}>
                           <span className={style.input_group_text}>
                              Nombre:{" "}
                           </span>
                           <input
                              className={style.input_field}
                              type="text"
                              placeholder="Ingrese nombre del Usuario"
                              name="username"
                              value={usuario.username}
                              onChange={handleChangeUser}
                              required
                           />
                        </div>
                        <div style={{ display: "block" }}>
                           <div className={style.input_group}>
                              <span className={style.input_group_text}>
                                 E-Mail:{" "}
                              </span>
                              <input
                                 className={style.input_field}
                                 type="text"
                                 placeholder="Email del Usuario"
                                 name="email"
                                 value={usuario.email}
                                 onChange={handleChangeUser}
                                 required
                              />
                           </div>
                           <div className={style.showerror}>
                              <p className={style.errormsg}>{mailError}</p>
                           </div>
                        </div>
                        <div className={style.input_group}>
                           <span className={style.input_group_text}>
                              CLave de acceso:{" "}
                           </span>
                           <input
                              className={style.input_field}
                              type="password"
                              placeholder="Ingrese una clave "
                              name="passwordHash"
                              value={usuario.passwordHash}
                              onChange={handleChangeUser}
                              required
                           />
                        </div>
                        <div className={style.input_group}>
                           <span className={style.input_group_text}>
                              Status:
                           </span>
                           <select
                              name="estadoId"
                              id="estadoId"
                              onChange={(e) => handleChange(e)}
                              value={usuario.estadoId}
                              className={style.input_field}
                           >
                              <option value="0">Seleccionar</option>
                              {estados &&
                                 estados.map((dat) => {
                                    return (
                                       <option
                                          selected
                                          value={dat.id}
                                          key={dat.id}
                                       >{`${dat.nombre}`}</option>
                                    );
                                 })}{" "}
                           </select>
                        </div>
                        <div>
                           {btnGrabar ? (
                              <button
                                 className={style.inputBtnNew}
                                 type="submit"
                              >
                                 {state ? "GRABAR" : "AGREGAR"}
                              </button>
                           ) : null}
                        </div>
                     </form>
                  </div>
               ) : null}
            </div>
         </div>
         <br />
         {input.id !== 0 ? (
            <>
               <div>
                  <button
                     className={style.inputBtnNew}
                     onClick={() => generarDefault()}
                  >
                     GRABAR DATOS DEFAULT
                  </button>
               </div>
               <div className={style.showerror}>
                  <p className={style.respuesta}>{respuesta}</p>
               </div>
            </>
         ) : null}
         <br />
         <div>
            <button
               className={style.inputBtnNew}
               onClick={() => {
                  navigate("/Compania");
               }}
            >
               VOLVER
            </button>
         </div>
      </>
   );
}

export default ABMCompanias;
